// redux/slices/userDataSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserDataPayload } from "./Types/UserData";

interface UserDataState {
  userData: UserDataPayload | null;
}

const initialState: UserDataState = {
  userData: null, // initially no data
};

const UserDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setUserData: (state, action: PayloadAction<UserDataPayload>) => {
      state.userData = action.payload;
    },
  },
});

export const { setUserData } = UserDataSlice.actions;
export default UserDataSlice.reducer;
